import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
localStorage.setItem("justLoggedIn", "true");

const Login = () => {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!phone || !password) {
      setMessage("Please enter both phone number and password.");
      return;
    }

    try {
      const res = await axios.post(`https://bullion-backend-5pu3.onrender.com/api/users/login`, {
        phone,
        password,
      });

      if (res.data.user) {
        localStorage.setItem("user", JSON.stringify(res.data.user));
        localStorage.setItem("token", res.data.token);
        navigate("/");
      }
    } catch (err) {
      setMessage(
        err.response?.data?.message || "Login failed. Try again later."
      );
    }
  };

  return (
    <PageWrapper>
      <Card>
        <BackButton onClick={() => navigate("/")}>← Back</BackButton>
        <Title>🔐 Login</Title>

        <StyledInput
          type="text"
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <StyledInput
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <StyledButton onClick={handleLogin}>Login</StyledButton>
        
         <BackBottomButton onClick={() => navigate("/register")}>
          Don’t have an account?
        </BackBottomButton>

<BackBottomButton onClick={() => navigate("/forgot-password")}>
  Forgot Password?
</BackBottomButton>
        {message && <ErrorText>{message}</ErrorText>}

      </Card>
    </PageWrapper>
  );
};

export default Login;

// Styled Components
const PageWrapper = styled.div`
  background-color: #000;
  color: #f5d76e;
  font-family: "Segoe UI", sans-serif;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const Card = styled.div`
  background-color: #111;
  padding: 2.5rem 2rem 2rem;
  border-radius: 12px;
  max-width: 400px;
  width: 100%;
  position: relative;
  box-shadow: 0 0 12px rgba(255, 215, 0, 0.2);
`;

const Title = styled.h2`
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 1.5rem;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 0.7rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid #f5d76e;
  background: #1a1a1a;
  color: #f5d76e;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #ffcc00;
  }
`;

const StyledButton = styled.button`
  width: 100%;
  padding: 0.8rem;
  border: none;
  border-radius: 8px;
  background-color: #f5d76e;
  color: #000;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background-color: #ffe58f;
  }
`;

const ErrorText = styled.p`
  margin-top: 1rem;
  text-align: center;
  color: #ff6b6b;
  font-size: 0.95rem;
`;

const BackButton = styled.button`
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: transparent;
  border: 1px solid #937676;
  color: #f5d76e;
  font-size: 0.9rem;
  border-radius: 6px;
  padding: 0.4rem 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f5d76e;
    color: #000;
  }
`;
const BackBottomButton = styled(StyledButton)`
  background-color: transparent;
  color: #f5d76e;
  font-weight: normal;
  font-size: 0.95rem;
  margin-top: 1rem;
  border: 1px solid #f5d76e;

  &:hover {
    background-color: #f5d76e;
    color: #000;
  }
`;

